import { http } from '@api/client';
import { PaginatedResponse } from '@api/shared/Pagination';
import { paramterize, pickResponse, pickResult } from '@api/utils';
import { CompanyContentRelation } from '@lib/company-content-relations';
import { NOT_SURE } from 'pages/company-to-person/edit/form';

export function get(vtr_id: string) {
  return http.get(`/entity-quote-policy/${vtr_id}`).pipe(pickResult());
}

export function post(payload) {
  return http.post(`/entity-quote-policy`, payload).pipe(pickResult());
}

export function put(person_company_rel_id = '', payload) {
  if (payload?.currently_working === NOT_SURE) {
    payload.currently_working = '';
  }
  return http.put(`/entity-quote-policy/${person_company_rel_id}`, payload).pipe(pickResult());
}

export function deleteQP({ vtr_id = '' }: { vtr_id: string }) {
  return http.delete(`/entity-quote-policy/${vtr_id}`).pipe(pickResult());
}

export interface QPSearchFilterParams {
  filters?: Array<{ id: string; value: Record<string, any> }>;
  pageSize?: number;
  page?: number;
  sortBy?: Array<{ id: string; desc: boolean }>;
}

export type FilterResponse = PaginatedResponse<QPDetails>;

/**
 * Filter deals using dynamic operators.
 * @param option Query options
 */
export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: QPSearchFilterParams = {}) {
  const sort = sortBy.map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`).join(';');
  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const resolveId = (id: string) => {
    return { buyers: 'buyer', sellers: 'seller', contents: 'content' }[id] || id;
  };
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [resolveId(f.id)]: Object.entries(f.value)
          .map(([op, v]) =>
            op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'vtr_company_type_id'
                ? `$in|||${v
                    .split(',')
                    .map(v => v.split('|||')[0])
                    .join(',')}`
                : `${op}|||${v.trim()}`,
          )
          .join(';'),
      }),
    {},
  );

  const params = paramterize({
    page_size,
    page,
    sort,
    // sort_buyers,
    // sort_sellers,
    // sort_contents,
    ...filtersMap,
  });

  return http.get<FilterResponse>('/entity-quote-policy/searches', { params }).pipe(pickResponse());
}

export interface QPDetails {
  vtr_id: string;
  company_vtr_id: string;
  company_name: string;
  person_vtr_id: string;
  person_name: string;
  designation: string;
  statement: string;
  statement_date: string;
  statement_type: string;
  source: string;
  ingestion_method: string;
  modified_at: string;
  updated_by: string;
}
